<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Posts Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" aria-label="Close filters">
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios" class="admin-filter-form-list">
    <h6 class="ion-text-left ion-padding-start">Media type</h6>
    <ion-radio-group mode="md" [(ngModel)]="media">
      <ion-item mode="ios" class="admin-filter-form-field" (click)="media = 'all'">
        <ion-label>All</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="all" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" class="admin-filter-form-field" (click)="media = 'image'">
        <ion-label>Image</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="image" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" class="admin-filter-form-field" (click)="media = 'video'">
        <ion-label>Video</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="video" color="warning"></ion-radio>
      </ion-item>
      @if (includePreviewModes) {
        <ion-item mode="ios" class="admin-filter-form-field" (click)="media = 'none'">
          <ion-label>None</ion-label>
          <ion-radio slot="start" class="custom-radio" mode="md" value="none" color="warning"></ion-radio>
        </ion-item>
        <ion-item mode="ios" class="admin-filter-form-field" (click)="media = 'skeleton'">
          <ion-label>Skeleton</ion-label>
          <ion-radio slot="start" class="custom-radio" mode="md" value="skeleton" color="warning"></ion-radio>
        </ion-item>
      }
    </ion-radio-group>
  </ion-list>
  @if (includeFeedTypes) {
    <ion-list lines="none" mode="ios" class="admin-filter-form-list">
      <ion-item mode="ios" class="admin-filter-form-field">
        <ion-select label="Feed type" label-placement="floating" [(ngModel)]="feedType" aria-label="Feed type">
          <ion-select-option value="all">All</ion-select-option>
          <ion-select-option value="Post">Posts</ion-select-option>
          <ion-select-option value="Slide">Slides</ion-select-option>
          <ion-select-option value="Collab">Collabs</ion-select-option>
          <ion-select-option value="Portfolio">Portfolios</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
  }
</ion-content>

<ion-footer mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-grid class="ion-no-padding">
      <ion-row class="admin-filter-actions">
        <ion-col size="6">
          <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="apply()">Apply</ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clear()">Clear</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
